import { Component, TemplateRef, OnInit, ViewChild } from '@angular/core';
import { BenchingDialogComponent } from '../../../gt2/benching/benching-dialog/benching-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Settings } from '../../../gt2/settings/settings';
import { NGXLogger } from 'ngx-logger';
import { GT2FirebaseService } from '../../../services/gt2-firebase.service';
import { CrudOrganizationService } from '../../../gt2/content/crud/crud-organization/crud-organization.service';
import { CrudEmployeeService } from '../../../gt2/content/crud/crud-employee/crud-employee.service';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import * as moment from 'moment-timezone';
import { Gt2ApiService } from '../../../gt2/api/gt2-api.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';
import { VersionCheckService } from '../../../services/version-check.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FuseDirectivesModule } from '../../../../@fuse/directives/directives';
import { FusePipesModule } from '../../../../@fuse/pipes/pipes.module';
import { NgxPermissionsModule } from 'ngx-permissions';

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [
    RouterModule,
    TranslateModule,
    MatButtonModule,
    MatInputModule,
    MatMenuModule,
    NgxPermissionsModule,
    MatIconModule,
    MatToolbarModule,
    MatTooltipModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FuseDirectivesModule,
    FusePipesModule,
  ],
})
export class FooterComponent implements OnInit {
  readonly environment = environment;

  @ViewChild('firebaseDialogTemplate', { static: false })
  firebaseDialogTemplate!: TemplateRef<any>;
  dialogRef: any;
  readonly settings = Settings;
  firebaseSubscription: Subscription;
  firebaseConnected: boolean = false;
  firebaseUid: string | null = null;
  firebaseProcessPath: string | null = null;
  firebaseTenantSlug: string | null = null;
  firebaseUserUuid: string | null = null;
  firebaseSubscriptionStatus: string = 'inactive';
  firebaseTokenPresent: boolean = false;
  firebaseSubscriptionError: string | null = null;
  timezone: string;
  isSmallScreen?: boolean;

  /**
   * Constructor
   */
  constructor(
    private _dialog: MatDialog,
    public translate: TranslateService,
    public logger: NGXLogger,
    public firebaseService: GT2FirebaseService,
    public api: Gt2ApiService,
    private breakpointObserver: BreakpointObserver,
    private afAuth: AngularFireAuth,
    private orgService: CrudOrganizationService,
    private employeeService: CrudEmployeeService,
    private versionCheckService: VersionCheckService,
  ) {
    this.firebaseSubscription = this.firebaseService.onConnectionStatus.subscribe({
      next: (connected: boolean) => {
        this.firebaseConnected = connected;
        this.firebaseSubscriptionStatus = connected ? 'active' : 'inactive/error';
      },
    });

    this.afAuth.authState.subscribe((user) => {
      this.firebaseUid = user ? user.uid : null;
    });

    this.firebaseService.onProcesses.subscribe({
      next: () => {
        this.updateFirebaseDebugInfo();
      },
    });

    this.firebaseService.onSubscriptionError.subscribe({
      next: (error: string | null) => {
        this.firebaseSubscriptionError = error;
      },
    });

    //
    this.timezone = moment.tz.guess();
  }
  ngOnInit(): void {
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe({
      next: (result) => {
        this.isSmallScreen = result.matches;
      },
    });
  }
  public onOpenAPICallBenching(): void {
    //this.logger.info("FuseFooterComponent.onOpenAPICallBenching()");
    // this.openBench.next();
    this.dialogRef = this._dialog.open(BenchingDialogComponent, {
      width: '780px',
      maxWidth: '100vw',
      maxHeight: '96vh',
      minWidth: '280px',
      panelClass: 'scrollable-dialog',
      disableClose: false,
    });

    this.dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result) {
        }
        this.dialogRef = null;
      },
    });
  }

  /**
   * Tapping the version label forces an update to the latest published build
   * (activate pending service-worker version + reload). Works on desktop,
   * mobile web and installed PWA.
   */
  public onForceUpdate(): void {
    this.versionCheckService.forceUpdate();
  }

  public onShowFirebaseStatus(): void {
    this.updateFirebaseDebugInfo();
    this.firebaseTokenPresent = !!localStorage.getItem('firebase_token');
    this.dialogRef = this._dialog.open(this.firebaseDialogTemplate, {
      panelClass: 'firebase-status-dialog',
    });
  }

  private updateFirebaseDebugInfo(): void {
    // currentTenantSlug is the TENANT SLUG (localStorage 'PREFIX' / App-Tenant),
    // which is the node the backend actually writes to on Firebase.
    this.firebaseTenantSlug = this.firebaseService.currentTenantSlug || null;

    // Get user.uuid from Firebase service or employee cache
    if (this.firebaseService.currentEmployee?.user) {
      this.firebaseUserUuid = this.firebaseService.currentEmployee.user.uuid;
    } else {
      const cachedEmployee = this.employeeService.getMeMe();
      if (cachedEmployee?.user?.uuid) {
        this.firebaseUserUuid = cachedEmployee.user.uuid;
      }
    }

    // Always compute expected paths from available data
    this.firebaseProcessPath = this.firebaseService.currentProcessesURL;
    if (this.firebaseTenantSlug && this.firebaseUserUuid) {
      if (!this.firebaseProcessPath) {
        this.firebaseProcessPath =
          environment.firebaseEnvironment + '/' +
          this.firebaseTenantSlug + '/' +
          this.firebaseUserUuid + '/processes';
      }
    }
  }
}
